import React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

const bugsnagClient = bugsnag({
  appType: 'client',
  appVersion: `${process.env.REACT_APP_GITSHA}`,
  apiKey: `${process.env.REACT_APP_BUGSNAG_KEY}`,
  releaseStage: process.env.REACT_APP_ENVIRONMENT,
  notifyReleaseStages: ['prod', 'qa'],
  collectUserIp: false,
  filters: [/token/i, /password/i, /name/i, /email/i, /phone/i],
});
bugsnagClient.use(bugsnagReact, React);

export default bugsnagClient;
